export default __webpack_public_path__ + "static/media/Snd1.00eb1a44.mp3";